import { render } from "./BloodMain.vue?vue&type=template&id=2952fd05"
import script from "./BloodMain.vue?vue&type=script&lang=js"
export * from "./BloodMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__